goog.provide("shadow.js.shim.module$$carbon$icons_react$es$ArrowDownRight$default");
shadow.js.shim.module$$carbon$icons_react$es$ArrowDownRight$default = shadow.js.require(348, {}).default;
